import { ReactNode, useEffect, useSyncExternalStore } from "react";
import { Spinner } from "../ui";
import { getAuthStatus, initAuth, subscribe } from "./session";

/**
 * Blocks the app until a parent-issued token arrives via postMessage.
 *
 * - `waiting`  → handshake in progress (spinner).
 * - `ready`    → token received; render the app.
 * - `denied`   → opened outside the iframe or no token arrived; hard stop.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  useEffect(() => {
    initAuth();
  }, []);

  const status = useSyncExternalStore(subscribe, getAuthStatus, getAuthStatus);

  if (status === "ready") return <>{children}</>;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.75rem",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      {status === "waiting" ? (
        <>
          <Spinner />
          <p style={{ opacity: 0.7 }}>Autenticando…</p>
        </>
      ) : (
        <>
          <p style={{ fontWeight: 600 }}>Acesso negado</p>
          <p style={{ opacity: 0.7, maxWidth: "28rem" }}>
            Esta página só pode ser aberta a partir do PharmaHub. Acesse pelo
            sistema para continuar.
          </p>
        </>
      )}
    </div>
  );
}